import React, { useEffect, useState } from "react";
import { Container, EachColumn, StatusDiv, StudentList } from "./style";
import {
  BoldMed,
  RegSmPri,
  HorizontalAlign,
  VerticalLeftAlign,
  RegSm,
  SpaceBetween,
  BoldSmPri,
  HorizontalLeftAlign,
  VerticalAlign,
} from "../CustomStyles";
import SearchBar from "../SearchBar";
import { useSelector, useDispatch } from "react-redux";
import {
  getCourseEnrollReqRequest,
  getUsersRequest,
  postApproveReqRequest,
  postCourseEnrollRequest,
} from "../../Redux/actions/home";
import Pagination from "../Pagination";
import ClipLoader from "react-spinners/ClipLoader";
import Colors from "../../Constant/Colors";

const UserListComponent = ({ list, reqList, course }) => {
  const { isInstructor } = useSelector((state) => state.auth);
  let { enrollReqList, user_count, req_count, userLoading } = useSelector(
    (state) => state.home
  );
  const dispatch = useDispatch();

  const [currentPage, setCurrentPages] = useState(1);
  const [userList, setUserList] = useState(list);
  const [searchUser, setSearchUser] = useState("");
  const [heading] = useState([
    "Name",
    "Courses",
    "Phone Number",
    "Email",
    // "Country",
    "Status",
  ]);
  const handleSearch = (key) => {
    setSearchUser(key);
    // let arr = [...list];
    // arr = arr.filter((f) =>
    //   f.first_name.toLowerCase().startsWith(key.toLowerCase())
    // );
    // setUserList(arr);
  };

  const approveRequest = (req) => {
    let data = {
      request_id: req?.request_id,
      student_id: req?.id,
      course_id: course?.id,
    };
    
    dispatch(postApproveReqRequest(data));
  };



  const setCurrentPage = (page) => {
    let offset = page * 7 - 7;
    let data = {
      course_id: course?.id,
      offset,
      name: searchUser ?? null,
    };
    if (reqList) {
      dispatch(getCourseEnrollReqRequest(data));
    } else {
      dispatch(getUsersRequest(data));
    }
    setCurrentPages(page);
  };

  const paginate = () => {
    setCurrentPage(1);
  };


  useEffect(() => {
    setUserList(list);
  }, [list]);

  useEffect(() => {
    let filterTimeout;

    if (searchUser.length >= 1) {
      const getUsers = () => {
        let data = { name: searchUser };
        if (reqList) {
          data["course_id"] = course?.id;
          dispatch(getCourseEnrollReqRequest(data));
        } else {
          dispatch(getUsersRequest(data));
        }
      };

      filterTimeout = setTimeout(() => {
        getUsers();
        setCurrentPage(1)
      }, 1000);
    } else {
      let data = {
        course_id: course?.id,
        offset: 0,
      };
      if (reqList) {
        dispatch(getCourseEnrollReqRequest(data));
      } else {
        dispatch(getUsersRequest(data));
      }
    }

    return () => clearTimeout(filterTimeout);
  }, [searchUser]);


  return (
    <Container reqList={reqList}>
      {/* --------------------------Main Heading ------------------------------ */}
      <SpaceBetween>
        <VerticalLeftAlign>
          <BoldMed>
            All{" "}
            {isInstructor
              ? `Students ${reqList ? "Request" : ""}`
              : "Instructors"}{" "}
            ({reqList ? req_count : user_count})
          </BoldMed>
          <RegSmPri>
            {!reqList
              ? `Active ${isInstructor ? "Students" : "Instructors"}`
              : ""}
          </RegSmPri>
        </VerticalLeftAlign>
        <HorizontalAlign>
          <SearchBar search={searchUser} handleSearch={handleSearch} />
        </HorizontalAlign>
      </SpaceBetween>
      {/* -------------------------- SearchBar ------------------------------ */}

      <StudentList>
        {heading.map((each) => (
          <EachColumn>
            <BoldSmPri>{each}</BoldSmPri>
          </EachColumn>
        ))}
      </StudentList>
      {userLoading ? (
        <VerticalAlign style={{ height: 100 }}>
          <ClipLoader color={Colors.primary} size={20} />
        </VerticalAlign>
      ) : userList?.length ? (
        <>
          <VerticalLeftAlign>
            {userList.map((each) => {
              let courses = [];
              if (each?.courses) {
                each.courses.forEach((fe) => courses.push(fe.title));
              } else {
                each.joined_courses.forEach((fe) => courses.push(fe.title));
              }
              courses = courses.join(", ");
              return (
                <StudentList key={each?.id}>
                  <EachColumn>
                    <RegSm style={{ textTransform: "capitalize" }}>
                      {each?.first_name ?? "N/A"}
                    </RegSm>
                  </EachColumn>
                  <EachColumn>
                    <RegSm>
                      {course?.title ? course?.title : courses ?? "N/A"}
                    </RegSm>
                  </EachColumn>
                  <EachColumn>
                    <RegSm>{each?.phone_number ?? "N/A"}</RegSm>
                  </EachColumn>

                  <EachColumn>
                    <RegSm>{each?.email ?? "N/A"}</RegSm>
                  </EachColumn>
                  <EachColumn style={{ paddingLeft: 10 }}>
                    <StatusDiv
                      status={each?.active}
                      onClick={
                        reqList && new Date().toISOString() < course?.end_date
                          ? () => approveRequest(each)
                          : null
                      }
                      reqList={reqList}
                      style={{ cursor: "pointer" }}
                    >
                      <p>
                        {reqList
                          ? "Approve Request"
                          : each?.active
                            ? "Active"
                            : "Inactive"}
                      </p>
                    </StatusDiv>
                  </EachColumn>
                </StudentList>
              );
            })}
          </VerticalLeftAlign>
        </>
      ) : (
        <HorizontalAlign style={{ marginTop: 20 }}>
          <RegSmPri>
            No{isInstructor ? " students " : " instructor "}to show
          </RegSmPri>
        </HorizontalAlign>
      )}
      <HorizontalAlign>
        <Pagination
          postsPerPage={7}
          totalPosts={reqList ? req_count : user_count}
          paginate={paginate}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </HorizontalAlign>
    </Container>
  );
};

export default UserListComponent;
